"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _utils = require("../utils");
var _dictionary = _interopRequireDefault(require("./dictionary"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const joinDefined = array => array.filter(item => item !== undefined).join(' ');
const useInputSupports = _ref => {
  let {
    label,
    feedback,
    validation,
    hint,
    nativeID,
    copy,
    maxCharacterAllowed,
    charactersCount
  } = _ref;
  const getCopy = (0, _utils.useCopy)({
    dictionary: _dictionary.default,
    copy
  });
  const hasValidationError = validation === 'error';
  const inputId = (0, _useUniqueId.default)('input');
  const hintId = (0, _useUniqueId.default)('input-hint');
  const feedbackId = (0, _useUniqueId.default)('input-feedback');
  const a11yProps = {
    accessibilityLabel: label,
    accessibilityHint: joinDefined([!hasValidationError && feedback, hint, maxCharacterAllowed ? getCopy('maxCharacters').replace(/%\{charCount\}/g, maxCharacterAllowed) : undefined]),
    // native only -> replaced with describedBy on web
    accessibilityDescribedBy: joinDefined([!hasValidationError && feedback && feedbackId,
    // feedback receives a11yRole=alert on error, so there's no need to include it here
    hint && hintId, charactersCount ? getCopy('charactersRemaining').replace(/%\{charCount\}/g, charactersCount) : undefined]),
    accessibilityInvalid: hasValidationError
  };
  return {
    inputId: nativeID || inputId,
    hintId,
    feedbackId,
    a11yProps
  };
};
var _default = exports.default = useInputSupports;